import { IComponent } from "./IComponent";
import { PageState } from "../services";

export class ConfirmSubmitComponent implements IComponent {
    element: Element;
    pageState: PageState;
    confirmShown = false;
    confirmed = false;
    modal: JQuery;
    attach(element: Element, pageState: PageState, previousState: any) {
        this.element = element;
        this.pageState = pageState;

        this.modal = $(".modal", this.element)
            .modal({
                closable: false,
                onDeny: () => {
                    this.confirmed = false;
                    this.confirmShown = false;
                },
                onApprove: () => {
                    this.confirmed = true;
                    $(element).submit();
                }
            });

        $(element).submit((ev) => {
            if (this.confirmShown) {
                if (!this.confirmed) {
                    return false;
                }
            } else {
                this.confirmShown = true;
                ev.preventDefault();
                this.modal.modal("show");
            }
        });
    }
    getState() {
        return null;
    }
}